import { Grid, Skeleton, Chip, Avatar } from "@mui/material";
import { getDocs } from "firebase/firestore/lite";
import { useEffect, useState, useCallback, useRef } from "react";
import ColorLine from "../../components/ColorLine";
import DashboardSlide from "../../components/DashboardSlide";
import {
  ProductColRefWithOrder,
  WorkDoneColRefWithOrder,
} from "../../database/Firebase";
import { useStyles } from "./StoreStyles";
import { useLocation } from "react-router-dom";
import StoreImageGrid from "../../components/StoreImageGrid";

import ScrollAnimation from "react-animate-on-scroll";
import { LocalStorage } from "../../cache/localStorage";
import { CompanyKey } from "../../constant";
import { Helmet } from "react-helmet";

const scrollToRef = (ref: any) =>
  window.scrollTo({ top: ref.current.offsetTop, behavior: "smooth" });

function StoreComponent() {
  let location = useLocation();

  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [ProductList, setProductList] = useState<any[]>([]);
  const [ProductSearchList, setProductSearchList] = useState<any>([]);
  const [selectedFilter, setSelectedFilter] = useState("");

  const [WorkDoneList, setWorkDoneList] = useState([]);

  // const [currentImage, setCurrentImage] = useState(0);
  // const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const sectionRef = useRef(null);
  // const executeSectionScroll = () => scrollToRef(sectionRef);

  // const openLightbox = useCallback((event, { photo, index }) => {
  //   setCurrentImage(index);
  //   setViewerIsOpen(true);
  // }, []);

  // const closeLightbox = () => {
  //   setCurrentImage(0);
  //   setViewerIsOpen(false);
  // };

  useEffect(() => {
    // eslint-disable-next-line
    getProduct();

    // eslint-disable-next-line
    getWorkDone();
  }, [location.pathname]);

  let getProduct = async () => {
    setIsLoading(true);
    const response = await getDocs(ProductColRefWithOrder);
    let storeProduct: any = [];
    response.forEach((doc) => {
      storeProduct.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    console.log(storeProduct);
    setProductList(storeProduct);
    setProductSearchList(storeProduct);
    setIsLoading(false);
  };

  let getWorkDone = async () => {
    setIsLoading(true);
    const response = await getDocs(WorkDoneColRefWithOrder);
    let storeWorkDone: any = [];
    response.forEach((doc) => {
      storeWorkDone.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    setWorkDoneList(storeWorkDone);
    setIsLoading(false);
  };

  const handleSearch = (value: string) => {
    const getItem = ProductList.filter(
      (item: any) => item && item.category && item.category === value
    );
    setProductSearchList(getItem);
  };

  return (
    <>
      {/* <ScrollingProvider> */}
      <section>
        <DashboardSlide
          title="Every Gifts Tells A Story"
          description=""
          color="yellow"
          img="giftBg"
        />
      </section>
      <ColorLine />
      <section ref={sectionRef}>
        <div className="marginContainer">
          <p className={classes.sectionTitle}> Welcome to our gift store!</p>
          <Grid
            container
            direction="row"
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Grid item sm={12} xs={12}>
              {/* <p
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: 18,
                }}
              >
                Welcome to our gift store!
              </p> */}
              <p style={{ textAlign: "center", marginTop: 20 }}>
                We specialize in arts and crafts, invitations and cards, photos
                and frames, corporate gifts, magazines, and customized and
                personalized gifts. Our selection of arts and crafts includes
                unique and handcrafted items that are perfect for any occasion.
                Our invitations and cards are beautifully designed and
                customizable for any event. We also have a wide variety of photo
                frames and albums to showcase your special memories. Our
                corporate gifts are perfect for businesses looking to show
                appreciation to clients or employees. We also offer a selection
                of magazines and personalized gifts that can be tailored to the
                individual's taste. With so many options to choose from, we're
                sure you'll find the perfect gift for any occasion.
              </p>
            </Grid>
          </Grid>
        </div>
      </section>

      <section style={{ paddingTop: 50 }}>
        <div className="marginContainer">
          <Grid
            container
            direction={"row"}
            alignItems={"center"}
            justifyContent="center"
            spacing={2}
            textAlign={"center"}
          >
            <Grid item sm={4}>
              <Chip
                onClick={() => {
                  handleSearch("Arts and Crafts");
                  setSelectedFilter("Arts and Crafts");
                }}
                size="medium"
                style={{
                  width: 250,
                  background:
                    selectedFilter === "Arts and Crafts" ? "#57b21d" : "none",
                  color:
                    selectedFilter === "Arts and Crafts" ? "white" : "black",
                }}
                variant="outlined"
                // avatar={
                //   <Avatar
                //     src={require("../../assets/blog-filter.png")}
                //   ></Avatar>
                // }
                label="Arts and Crafts"
              />
            </Grid>
            <Grid item sm={4}>
              <Chip
                onClick={() => {
                  handleSearch("Invitation and Cards");
                  setSelectedFilter("Invitation and Cards");
                }}
                size="medium"
                style={{
                  width: 250,
                  background:
                    selectedFilter === "Invitation and Cards"
                      ? "#57b21d"
                      : "none",
                  color:
                    selectedFilter === "Invitation and Cards"
                      ? "white"
                      : "black",
                }}
                variant="outlined"
                // avatar={
                //   <Avatar
                //     src={require("../../assets/blog-filter.png")}
                //   ></Avatar>
                // }
                label="Invitation and Cards"
              />
            </Grid>
            <Grid item sm={4}>
              <Chip
                onClick={() => {
                  handleSearch("Photos and Frames Gifts");
                  setSelectedFilter("Photos and Frames Gifts");
                }}
                size="medium"
                style={{
                  width: 250,
                  background:
                    selectedFilter === "Photos and Frames Gifts"
                      ? "#57b21d"
                      : "none",
                  color:
                    selectedFilter === "Photos and Frames Gifts"
                      ? "white"
                      : "black",
                }}
                variant="outlined"
                // avatar={
                //   <Avatar
                //     src={require("../../assets/blog-filter.png")}
                //   ></Avatar>
                // }
                label="Photos and Frames Gifts"
              />
            </Grid>
            <Grid item sm={4}>
              <Chip
                onClick={() => {
                  handleSearch("Corporate Gifts");
                  setSelectedFilter("Corporate Gifts");
                }}
                size="medium"
                style={{
                  width: 250,
                  background:
                    selectedFilter === "Corporate Gifts" ? "#57b21d" : "none",
                  color:
                    selectedFilter === "Corporate Gifts" ? "white" : "black",
                }}
                variant="outlined"
                // avatar={
                //   <Avatar
                //     src={require("../../assets/blog-filter.png")}
                //   ></Avatar>
                // }
                label="Corporate Gifts"
              />
            </Grid>
            <Grid item sm={4}>
              <Chip
                onClick={() => {
                  handleSearch("Magazines");
                  setSelectedFilter("Magazines");
                }}
                size="medium"
                style={{
                  width: 250,
                  background:
                    selectedFilter === "Magazines" ? "#57b21d" : "none",
                  color: selectedFilter === "Magazines" ? "white" : "black",
                }}
                variant="outlined"
                // avatar={
                //   <Avatar
                //     src={require("../../assets/blog-filter.png")}
                //   ></Avatar>
                // }
                label="Magazines"
              />
            </Grid>
            <Grid item sm={4}>
              <Chip
                onClick={() => {
                  handleSearch("Customized and Personalized gifts");
                  setSelectedFilter("Customized and Personalized gifts");
                }}
                size="medium"
                style={{
                  width: 250,
                  background:
                    selectedFilter === "Customized and Personalized gifts"
                      ? "#57b21d"
                      : "none",
                  color:
                    selectedFilter === "Customized and Personalized gifts"
                      ? "white"
                      : "black",
                }}
                variant="outlined"
                // avatar={
                //   <Avatar
                //     src={require("../../assets/blog-filter.png")}
                //   ></Avatar>
                // }
                label="Customized and Personalized gifts"
              />
            </Grid>
          </Grid>
          {selectedFilter && (
            <p
              onClick={() => {
                handleSearch("");
                setSelectedFilter("");
                setProductSearchList(ProductList);
              }}
              style={{ textAlign: "center", color: "#57b21d", marginTop: 10 }}
            >
              <span style={{ cursor: "pointer" }}>clear</span>
            </p>
          )}
        </div>
      </section>

      <section>
        <div className="marginContainer">
          <Grid
            pt={10}
            pb={10}
            container
            justifyContent={"center"}
            alignItems={"center"}
          >
            {/* {!ProductList.length && (
              <Skeleton variant="rectangular" width={"100%"} height={518} />
            )} */}
            {ProductSearchList.length ? (
              <StoreImageGrid ImageData={ProductSearchList} />
            ) : (
              <p> No Product Found ! </p>
            )}
          </Grid>
        </div>
      </section>
      <section>
        <div className="marginContainer">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ textAlign: "center" }}
            pt={10}
            pb={10}
          >
            <ScrollAnimation animateIn="fadeIn">
              <Grid
                sx={{
                  display: { xs: "none", lg: "block" },
                }}
                item
                style={{ textAlign: "center" }}
              >
                <a
                  target="_blank"
                  href={
                    LocalStorage.get(CompanyKey)
                      ? LocalStorage.get(CompanyKey).banner_link
                      : ""
                  }
                >
                  <Avatar
                    variant="square"
                    sx={{ width: "100%", height: 200 }}
                    alt="juju Designz salem"
                    src={
                      LocalStorage.get(CompanyKey)
                        ? LocalStorage.get(CompanyKey).adsUrl
                        : ""
                    }
                  />
                </a>
              </Grid>
              <Grid
                sx={{
                  display: { xs: "block", lg: "none" },
                }}
                xs={12}
                item
                style={{ textAlign: "center" }}
              >
                <a
                  target="_blank"
                  href={
                    LocalStorage.get(CompanyKey)
                      ? LocalStorage.get(CompanyKey).banner_link
                      : ""
                  }
                >
                  <Avatar
                    variant="square"
                    sx={{ width: "100%", height: 200 }}
                    alt="juju Designz salem"
                    src={
                      LocalStorage.get(CompanyKey)
                        ? LocalStorage.get(CompanyKey).adsPortraitUrl
                        : ""
                    }
                  />
                </a>
              </Grid>
            </ScrollAnimation>
          </Grid>
        </div>
      </section>
      {/* SEO */}
      <Helmet>
        <title>JuJu Designz Store</title>
        <meta
          name="description"
          content="JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider  juju designs juju, designsz of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated  juju designs juju, designsz and  juju designs juju, designsz amused to see our customers exhilarated. location : salem , Tamil Nadu , graphics design , web designing , mobile app development . best startup in salem , best web development in salem , juju designs juju, designsz.salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation.JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a >good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store"
        />
      </Helmet>
    </>
  );
}

export default StoreComponent;
